import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import materials from './materials.json';

const UsefulMaterials = () => {
  return (
    <div className="max-w-7xl mx-auto my-[120px]">
      <div className="bg-white shadow rounded-lg p-[60px]">
        <div className="container my-[40px]">
          <div className="row justify-content-center">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-10">
              Полезные матералы
            </h2>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {materials.map((mat, index) =>
              <div key={index} className="border border-gray-200 rounded hover:shadow-md transition-shadow">
                <div className="flex flex-col h-full justify-between">

                  {/* <img src="`${mat[\"image\"]}`" className="card-img-top d-none" /> */}
                  <div className="card-title text-xl text-bold text-center px-3 py-3">
                    {mat["title"]}
                  </div>

                  <div className="p-4 text-center border-t border-gray-100">
                    {mat["annotation"]}
                  </div>

                  <div className="p-4 text-center border-t border-gray-100">
                    <Link to={mat['link']} target="_blank" className="no-underline">
                      <h3 className="text-xl font-semibold text-[#c0834d] mb-2">
                        Скачать
                      </h3>
                    </Link>
                  </div>
                  
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsefulMaterials; 
